import React, { useState, useRef, useEffect } from "react";
import { Dialog } from "primereact/dialog";
import "./PreviewMedia.scss"

/*const esImagen = (url) => {
    return /\.(jpg|jpeg|png|gif|webp)$/i.test(url);
};*/

const esImagen = (url) => /\.(jpg|jpeg|png|gif|webp)$/i.test(url);

//modificado 2
const PreviewMedia = ({
    urlFile,
    visibleModal,
    onHide,
    maxWidth = "80vw", // "70vw",
    maxHeight = "80vh", // 70
}) => {
    const viewportRef = useRef(null);

    const onImageLoad = (e) => {
        const img = e.target;
        const ratio = img.naturalWidth / img.naturalHeight;

        if (viewportRef.current) {
            viewportRef.current.style.aspectRatio = ratio;
        }
    };

    return (
        <Dialog
            visible={visibleModal}
            onHide={onHide}
            className="p-eva-PreviewMedia"
            style={{
                 width: maxWidth, // "90vw",
                 //height: "80vh"   // 👈 FORZAMOS ALTURA REAL
            }}            
             contentStyle={{
                 height: maxHeight, //"80vh",   // 👈 FORZAMOS ALTURA REAL
                padding: 0,
                 overflow: "auto"
             }}
            modal
        >
            <div  className="p-eva-PreviewMedia-viewport">
                <img src={urlFile} alt="preview" />
            </div>
        </Dialog>
    );
};

export default PreviewMedia;



//QAS
/*const PreviewMedia = ({urlFile, visibleModal=false,onHide,maxWidth,height=90}) => {
    const [visible, setVisible] = useState(false);
    useEffect(()=>{
        setVisible(visibleModal)
    },[visibleModal])
    return ( 
        <Dialog visible={visible}  onHide ={onHide} className="p-eva-PreviewMedia" 
            style={{height:height+"vh",maxWidth:maxWidth}} >

            <div className="p-eva-PreviewMedia-contenido" style={{height:(height-3)+"vh"}}>
                    <embed style={{borderRadius:16}}
                        width="100%" 
                        height="100%" 
                        src={urlFile}
                        allowfullscreen></embed>
            </div>
            

        </Dialog>
    );
}
 
export default PreviewMedia;   */

//PRD
/*const PreviewMedia = ({urlFile, visibleModal=false,onHide,maxWidth,height=90}) => {
    const [visible, setVisible] = useState(false);
    useEffect(()=>{
        setVisible(visibleModal)
    },[visibleModal])
    return ( 
        <Dialog visible={visible}  onHide ={onHide} className="p-eva-PreviewMedia" 
            style={{height:height+"vh",maxWidth:maxWidth}} >

            <div className="p-eva-PreviewMedia-contenido" style={{height:(height-3)+"vh"}}>
                    <embed style={{borderRadius:16}}
                        width="100%" 
                        height="100%" 
                        src={urlFile}
                        allowfullscreen></embed>
            </div>
            

        </Dialog>
    );
}
export default PreviewMedia;*/

//modificado 1
// const PreviewMedia = ({ urlFile, visibleModal = false, onHide, maxWidth = "7vw", height = 70 }) => {

//     const [visible, setVisible] = useState(false);    

//     useEffect(() => {
//         setVisible(visibleModal);
//     }, [visibleModal]);

//     return (
//         <Dialog
//             visible={visible}
//             onHide={onHide}
//             className="p-eva-PreviewMedia"
//              style={{ height: `${height}vh`, maxWidth }}
//             //style={{ maxHeight: `${height}vh`, maxWidth: maxWidth }}
//             modal
//             draggable={false}
//             resizable={false}
//         >
//             {/* <div className="p-eva-PreviewMedia-contenido">
//                 {esImagen(urlFile) ? (
//                     <img src={urlFile} alt="preview" />
//                 ) : (
//                     <embed src={urlFile} />
//                 )}
//             </div> */}
//               <div className="p-eva-PreviewMedia-viewport">
//                 <img src={urlFile} alt="preview" />
//             </div> 
//         </Dialog>
//     );
// };
// export default PreviewMedia;
